/* Dolosway board — runners, art, spaces, costs, dice pips, roster, fresh game factory, crown vault key */
import { Flag, Package, Skull, Swords, Tent } from "lucide-react";

export const TOKENS = {
  dolo: "/assets/board-dolo.png",
  kishuu: "/assets/board-kishuu.png",
  funk: "/assets/board-funk.png",
  guard: "/assets/board-guard.png",
  redforce: "/assets/board-redforce.png",
};

export const ART = {
  dolo: "/assets/art-dolo.png",
  kishuu: "/assets/art-kishuu.png",
  funk: "/assets/art-funk.png",
  guard: "/assets/art-guard.png",
  redforce: "/assets/art-redforce.png",
};

export const SPACES = [
  { t: "go", n: "GO CAMP" },
  { t: "plot", n: "RUST YARD" },
  { t: "supply", n: "SUPPLY DROP" },
  { t: "plot", n: "FUEL DEPOT" },
  { t: "chance", n: "WASTE CARD" },
  { t: "raid", n: "AMBUSH ALLEY" },
  { t: "camp", n: "SAFE CAMP" },
  { t: "plot", n: "SCRAP TOWN" },
  { t: "supply", n: "CACHE" },
  { t: "plot", n: "DUST MARKET" },
  { t: "chance", n: "WASTE CARD" },
  { t: "worm", n: "WORM SIGN" },
  { t: "camp", n: "SAFE CAMP" },
  { t: "plot", n: "CANYON PASS" },
  { t: "supply", n: "SUPPLY DROP" },
  { t: "plot", n: "IRON FLATS" },
  { t: "chance", n: "WASTE CARD" },
  { t: "raid", n: "AMBUSH ALLEY" },
  { t: "camp", n: "SAFE CAMP" },
  { t: "plot", n: "RUNWAY RUIN" },
  { t: "supply", n: "CACHE" },
  { t: "plot", n: "DOLOSWAY" },
  { t: "chance", n: "WASTE CARD" },
  { t: "worm", n: "WORM SIGN" },
];

export const CLAIM_COST = 20;
export const TOLL = 15;
export const GO_BONUS = 30;
export const STARVE_COST = 10;
export const BUILD_PARTS = 3;

export const PIPS = { 1: [4], 2: [0, 8], 3: [0, 4, 8], 4: [0, 2, 6, 8], 5: [0, 2, 4, 6, 8], 6: [0, 2, 3, 5, 6, 8] };

export const rand6 = () => 1 + Math.floor(Math.random() * 6);

export function cellOf(i) {
  if (i === 0) return [7, 7];
  if (i <= 6) return [7, 7 - i];
  if (i <= 11) return [13 - i, 1];
  if (i === 12) return [1, 1];
  if (i <= 17) return [1, i - 11];
  if (i === 18) return [1, 7];
  return [i - 17, 7];
}

export const SPACE_ICONS = {
  go: Tent,
  plot: Flag,
  supply: Package,
  chance: null,
  raid: Swords,
  worm: Skull,
  camp: Tent,
};

export const ROSTER = [
  { id: "dolo", name: "DOLO", color: "#ff0033" },
  { id: "kishuu", name: "KISHUU", color: "#c77dff" },
  { id: "funk", name: "FUNK MASTER", color: "#00c8ff" },
  { id: "guard", name: "WHITE GUARD", color: "#e8e6e3" },
  { id: "redforce", name: "RED FORCE", color: "#ff9900" },
];

export function freshPlayers(youId = "dolo") {
  return ROSTER.map((p) => ({ ...p, you: p.id === youId, pos: 0, scrap: 100, food: 3, weapons: 1, dbl: 0, hwy: 3, stopped: false, parts: { car: 0, home: 0, plane: 0 }, builds: [], alive: true }));
}

export function freshGame(youId = "dolo") {
  return {
    players: freshPlayers(youId),
    youId,
    started: false,
    plots: {},
    turn: ROSTER.findIndex((r) => r.id === youId),
    dice: [1, 1],
    rolling: false,
    lastDoubles: false,
    wormFlash: false,
    airFlash: false,
    turnFlash: false,
    wormHit: null,
    airHit: null,
    clashHit: null,
    supplyHit: null,
    chanceHit: null,
    campHit: null,
    hwyHit: null,
    hwyChoice: null,
    payHit: null,
    deathHit: null,
    log: [{ line: "WELCOME TO THE DOLOSWAY. ROLL THE BONES.", color: "#ff0033", id: 0 }],
    winner: null,
  };
}

export const BOARD_KEY = "apocalypse-board-crowns";

export const loadCrowns = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(BOARD_KEY));
    if (parsed && typeof parsed === "object") {
      return Object.fromEntries(Object.entries(parsed).filter(([, v]) => Number.isFinite(v) && v > 0));
    }
  } catch {}
  return {};
};
